if (!customElements.get('st-buy-now')) {
  customElements.define('st-buy-now', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.source = document.getElementById(this.dataset.sourceForm);
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.sourceButton = this.source?.querySelector('[name="add"]');
      const root = this.closest('product-info');
      if (!this.source || !this.sourceButton || !root) { this.button.disabled = true; return; }
      this.sync = () => {
        const variant = this.source.elements.namedItem('id');
        const quantity = this.source.elements.namedItem('quantity');
        this.form.elements.namedItem('id').value = variant?.value || '';
        this.form.elements.namedItem('quantity').value = quantity?.value || '1';
        this.button.disabled = !variant?.value || variant.disabled || this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
      };
      root.addEventListener('change', this.sync, {signal});
      root.addEventListener('input', this.sync, {signal});
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.sourceButton, {attributes:true,attributeFilter:['disabled','aria-disabled']});
      this.form.addEventListener('submit', event => {
        this.sync();
        const quantity = this.source.elements.namedItem('quantity');
        if (this.button.disabled || (quantity && !quantity.reportValidity())) event.preventDefault();
      }, {signal});
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.abort = null; }
  });
}
